import { ActivatedRouteSnapshot, RouteReuseStrategy, DetachedRouteHandle } from '@angular/router';

export class CustomReuseStrategy implements RouteReuseStrategy {
  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return false; // Never detach any routes
  }

  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {}

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return false; // Never attach stored routes
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    return null; // Don't retrieve stored routes
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    if (future.routeConfig !== curr.routeConfig) {
      return false;
    }

    // Routes can opt out of recreation for specific params via `data.reuseIgnoreParams`
    // (e.g. the system page reuses the component when only `:tab` changes, so the header
    // stays mounted and only the tab content swaps instead of re-rendering the whole page).
    const ignoreParams = future.routeConfig?.data?.['reuseIgnoreParams'] as string[] | undefined;
    if (ignoreParams?.length) {
      const stripIgnored = (params: Record<string, unknown>) => {
        const clone = { ...params };
        ignoreParams.forEach(key => delete clone[key]);
        return clone;
      };
      return JSON.stringify(stripIgnored(future.params)) === JSON.stringify(stripIgnored(curr.params));
    }

    return JSON.stringify(future.params) === JSON.stringify(curr.params);
  }
}
